import React, { forwardRef } from 'react'
import { UserAvatar } from './UserAvatar'
import { InitialsAvatar } from './InitialsAvatar'
import { DefaultAvatar } from './DefaultAvatar'
import { SIZE } from '../../../../ui/Avatar/StyledAvatar'

export const Avatar = forwardRef(({ userInfo, onClick }, ref) => {
  if (!userInfo) {
    return <div style={{ width: `${SIZE}px` }}/>
  }

  const { firstName = '', lastName = '', avatar = '' } = userInfo

  if (avatar !== '') {
    return (
      <UserAvatar
        src={avatar}
        onClick={onClick}
        ref={ref}
      />
    )
  }

  if (firstName !== '' || lastName !== '') {
    return (
      <InitialsAvatar
        firstName={firstName}
        lastName={lastName}
        onClick={onClick}
        ref={ref}
      />
    )
  }

  return <DefaultAvatar onClick={onClick} ref={ref} />
})
